import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import styles from './IconRow.module.css';
import { IIconRow, IIconRowIcon } from "src/lib/types/IForsidenV2";

//#region [Props]
type IconRowProps = {
    block: IIconRow;
};
//#endregion

//#region [Component]
export default function IconRow({ block }: IconRowProps) {
    return <div className={styles.SIconRow}>
        {block.icons.map(icon => <Icon key={icon._key} icon={icon} />)}
    </div>;
}
//#endregion

type IconProps = {
    icon: IIconRowIcon;
}

function Icon({ icon }: IconProps) {
    let svg = icon.svg.replaceAll("radialGradient", "linearGradient");
    svg = svg.replaceAll(/<linearGradient.*?id=(.*?) .*?>/g, "<linearGradient id=$1 gradientTransform='rotate(-20)'>");
    return <FilmwebLink className={styles.SIconLink} to={icon.link}>
        <div dangerouslySetInnerHTML={{ __html: svg }} />
        <span className={styles.SIconText}>{icon.title}</span>
        {!!icon.subtitle && <span className={styles.SIconText}>{icon.subtitle}</span>}
    </FilmwebLink>
}

//#endregion
